import { AppRegistry } from "react-native";
import App from "./App";

console.log('teste')

AppRegistry.registerComponent("App", () => App);

console.log(document.getElementById("root"))

AppRegistry.runApplication("App", {
  rootTag: document.getElementById("root")
});

// import React from 'react';
// import ReactDOM from 'react-dom';
// import App2 from './App2';
// import reportWebVitals from './reportWebVitals';

// console.log("teste")

// ReactDOM.render(
//   <React.StrictMode>
//     <App2 />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();